import React, { memo } from 'react';

import { Paper } from '../../material-ui/Paper';
import { SystemMeasure } from '../../SystemMeasure/SystemMeasure';
import { WeightUnits } from '../../WeightUnits/WeightUnits';
import { useMeasureConverter } from '../../hooks/useMeasureConverter';
import { useMeasurePanel } from './useMeasurePanel';
import { useShowSystemMeasureToggler } from './useShowSystemMeasureToggler';
import { useStyles } from './useStyles';

export const MeasurePanel = memo(() => {
    useMeasureConverter();

    const { currentLeg, page, handleWeightUnitsChange } = useMeasurePanel();
    const { isUsedCfpWeightUnits, showSystemMeasureToggler, showWeightUnitsBadge, currentWeightUnits, weightUnitsForBadge } =
        useShowSystemMeasureToggler(page);

    const classes = useStyles();

    if (!isUsedCfpWeightUnits) {
        return null;
    }

    return (
        <div className={classes.content}>
            {showSystemMeasureToggler && (
                <SystemMeasure
                    className={classes.switchMeasure}
                    legID={currentLeg}
                    weightUnits={currentWeightUnits}
                    onWeightUnitsChange={handleWeightUnitsChange}
                />
            )}
            {showWeightUnitsBadge && (
                <Paper className={classes.paper} elevation={0}>
                    <WeightUnits weightUnits={weightUnitsForBadge} />
                </Paper>
            )}
        </div>
    );
});

MeasurePanel.displayName = 'MeasurePanel';
